export const CoachOfferType = {
  Individual: "INDIVIDUAL",
  Collective: "COLLECTIVE",
} as const
export type CoachOfferType = (typeof CoachOfferType)[keyof typeof CoachOfferType]

export const CoachPaymentOfferType = {
  Subscription: "SUBSCRIPTION",
  TicketsBook: "TICKETS_BOOK",
  Free: "FREE",
} as const
export type CoachPaymentOfferType = (typeof CoachPaymentOfferType)[keyof typeof CoachPaymentOfferType]
